var render = function render(){var _vm=this,_c=_vm._self._c;return _c('multiselect',{attrs:{"options":_vm.options,"placeholder":_vm.$t('sampleTypeDropdownPlaceholder'),"custom-label":_vm.customLabel,"show-labels":_vm.showLabels},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }